import { render } from "./AccountingDatatablePaymentTypeTD.vue?vue&type=template&id=e6bed25a"
import script from "./AccountingDatatablePaymentTypeTD.vue?vue&type=script&lang=js"
export * from "./AccountingDatatablePaymentTypeTD.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__